<template>
  <el-dialog
    :title="title"
    :visible="visible"
    @update:visible="val => $emit('update:visible', val)"
    :width="width"
    custom-class="base-delete-dialog">

    <div class="base-delete-dialog__body">
      <div class="base-delete-dialog__icon">
        <i class="el-icon-warning"></i>
      </div>
      <p class="base-delete-dialog__text">
        <slot>{{ text }}</slot>
      </p>
    </div>

    <span slot="footer" class="base-delete-dialog__footer">
      <el-button @click="$emit('update:visible', false)">
        {{ $t('base.cancel') }}
      </el-button>
      <el-button type="danger" :loading="loading" @click="$emit('confirm')">
        <i class="el-icon-delete"></i> {{ confirmLabel || $t('base.delete') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'BaseDeleteDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    confirmLabel: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '420px',
    },
  },
};
</script>

<style lang="scss">
.base-delete-dialog {
  border-radius: 12px !important;
  overflow: hidden;

  .el-dialog__header {
    padding: 20px 24px 16px;
    border-bottom: 1px solid #f0f0f0;

    .el-dialog__title {
      font-size: 16px;
      font-weight: 600;
      color: var(--text-primary);
    }

    .el-dialog__headerbtn {
      top: 20px;
      right: 20px;
    }
  }

  .el-dialog__body {
    padding: 24px;
  }

  .el-dialog__footer {
    padding: 16px 24px;
    border-top: 1px solid #f0f0f0;
  }

  &__body {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 14px;
    padding: 8px 0 12px;
  }

  &__icon {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    background: #fff4f4;
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: 24px;
      color: var(--danger);
    }
  }

  &__text {
    margin: 0;
    font-size: 14px;
    color: var(--text-secondary);
    line-height: 1.6;
    max-width: 320px;
    word-break: normal;
    overflow-wrap: break-word;
    hyphens: none;
    word-break: normal;
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
}
</style>
